import '../scss/customer.scss';
import '../components/form-addresses';
import '../components/register-info-customer';
import '../components/mes-alerts-account';
import { $Q } from '../utils/query-selector';
import { togglePassword } from '../components/show-password';
import { initializeSideMenu } from '../components/side-menu';
import { initCustomerOrder } from '../components/customer-order';
import { handleAccountNewsletter } from '../components/newsletter-account';
import { removeSelected } from '../components/wishlist/removeSelected';

const toggleContainer = (elementShow, elementhidden) => {
  $Q(elementShow).dataset.active = true;
  $Q(elementhidden).dataset.active = false;
};

(function recoverToggle() {
  if (!$Q('#display-recover')) return;

  $Q('#display-recover').addEventListener('click',
    () => toggleContainer('#recover-container', '#login-container')
  );

  $Q('#recover-hidden').addEventListener('click',
    () => toggleContainer('#login-container', '#recover-container')
  );
}());

(function handleRefundButton() {
  const refundBtn = $Q('.customer__refund');
  if (!refundBtn) return;

  const href = refundBtn.getAttribute('href');

  if (!href || href === '/') {
    refundBtn.addEventListener('click', (event) => {
      event.preventDefault();

      const refundTab = $Q('.account-sidebar__link[title~="Livraisons"]');
      if (!refundTab);

      refundTab.click();
    })
  }
}());

togglePassword();
handleAccountNewsletter();

if (window.location.pathname.includes('account')) {
  initializeSideMenu();
  initCustomerOrder();
}
